import script from "./AddCandidateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddCandidateModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddCandidateModal.vue?vue&type=style&index=0&id=65fbaf8b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fbaf8b"]])

export default __exports__